import { KeyTextField } from '@prismicio/client'
import { MATERIAL_ICONS_BASE } from '@dtx-company/design-system/src/components/DynamicMuiIcon/constants'
import Image from 'next/image'
import React, { FC } from 'react'

export const ChipIcon: FC<{ icon: KeyTextField }> = ({ icon }) => (
  <Image
    alt=""
    role="presentation"
    src={`${MATERIAL_ICONS_BASE}/${icon}_24px.svg`}
    width={18}
    height={18}
    priority
  />
)
